import { SET_API } from '../mutation-type'
import state from 'src/config/api'

// mutations
const mutations = {
  [SET_API] (state, config) {
    // state = config
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/api.js